export default {"src":"/_next/static/media/definition-illu.fd9afb3e.svg","height":66,"width":69,"blurWidth":0,"blurHeight":0};